import React, { FC } from 'react'
import { OrderedListItemModel, RequestParams } from 'Models'
import { GridHeaderColumnLIStyled, GridHeaderColumnULStyled, RoleSelect } from 'LibNeo'
import { CustomSlugIE, interfaceElementSlice } from 'Pages/interfaceElement'
import { useAppDispatch } from 'Src/hooks'

interface ComponentProps {
	columns: OrderedListItemModel[]
}

const actions = {
	getRoleAll: interfaceElementSlice.actions.getAllRole,
	setRoleRequestParams: interfaceElementSlice.actions.setRoleRequestParams,
}

export const CustomHeader: FC<ComponentProps> = ({ columns }) => {
	const { getRoleAll, setRoleRequestParams } = useAppDispatch(actions)
	const changeRole = (role_id: number): void => {
		const requestParams = new RequestParams(1, 1000, null, { role_id })
		getRoleAll(requestParams)
		setRoleRequestParams(requestParams)
	}
	const renderCustomHeader = () => {
		return (
			<GridHeaderColumnULStyled>
				{columns.map((column: OrderedListItemModel) => (
					<GridHeaderColumnLIStyled key={column.slug} width={column.width}>
						{column.slug === CustomSlugIE.ROLE ? (
							<RoleSelect
								allowClear
								fieldName="role_id"
								placeholder="orders.role"
								label=""
								onChange={changeRole}
							/>
						) : (
							column.name
						)}
					</GridHeaderColumnLIStyled>
				))}
			</GridHeaderColumnULStyled>
		)
	}
	return renderCustomHeader()
}
